import React from 'react';
import styled from 'styled-components';
import ConfirmDepartureImage from '../../assets/departureWifi/confirm_departure.png';

type Props = {
  isDetailStep?: boolean;
};

function Step2({ isDetailStep = false }: Props) {
  const titleText = isDetailStep ? (
    <>
      출국 인증하기 버튼을
      <br />
      클릭해주세요
    </>
  ) : (
    '출국 인증하기 버튼 클릭'
  );
  return (
    <Container isDetailStep={isDetailStep}>
      <StepLabel className='notranslate'>Step 2</StepLabel>
      <Title isDetailStep={isDetailStep}>{titleText}</Title>
      <Description>
        와이파이가 정상적으로 연결되었다면
        <br />
        하단의 '출국 인증하기' 버튼을 클릭해주세요.
      </Description>
      <img src={ConfirmDepartureImage} alt='' width='100%' />
    </Container>
  );
}

const Container = styled.div<{ isDetailStep?: boolean }>`
  ${({ isDetailStep = false }) =>
    isDetailStep &&
    `
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      text-align: center;
    `}
`;

const StepLabel = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 100px;
  background-color: #246cf6;
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  flex-basis: auto;
  margin-bottom: 12px;
`;

const Title = styled.h2<{ isDetailStep?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ isDetailStep = false }) =>
    isDetailStep ? 'center' : 'flex-start'};
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
  color: #3a3b3e;
  margin-bottom: 8px;
  line-height: 27px;

  & > img {
    width: 36px;
    height: 36px;
  }
`;

const Description = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #80848a;
  margin-bottom: 16px;
`;

export default Step2;
